import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LogoComponent } from '@ui/layout/logo/logo.component';


/**
 * Footer
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [
        LogoComponent,
    ],
})
export class FooterComponent {
    /**
     * Year in copyright
     */
    public readonly year: number = new Date().getFullYear();
}
